export const DEFAULT_THANK_YOU_IMAGE = 'https://ik.imagekit.io/magictap/thank-you-page.svg';
